import styles from "./LoanCalculator.module.scss";
interface Props {
  noImage?: boolean;
  className?: string;
  id?: string;
  children?: React.ReactNode;
}
const LoanCalculatorSectionWrapper: React.FC<Props> = (props) => {
  const { noImage, className, id } = props;
  return (
    <section className={`${styles.textSection}`} id={id}>
      <div className={`${styles.textSectionContainer} ${noImage ? styles.noImage : ""} ${className}`}>
        {props.children}
      </div>
    </section>
  );
};

export default LoanCalculatorSectionWrapper;
